// removed by extract-text-webpack-plugin
module.exports = {"spinner":"WEFNkBy2HX3o5x2aZLncq"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/PlanModal/styles.scss
// module id = 632
// module chunks = 11